import { baseBUCGet } from '../base/baseBUC';

const decimal = 0.00;

export const apartmentReceiptDetailModelGet = ({
    buildingId = '',
    apartmentId = '',
    receiptId = '',
    apartmentReceiptId = '',
    expenseConceptId = '',
    userId = '',
}) => {
    return {
        //buildingId: buildingId,
        apartmentId: apartmentId,
        receiptId: receiptId,
        apartmentReceiptId: apartmentReceiptId,
        expenseConceptId: expenseConceptId,
        //userId: userId,
        //created: dateTimeStr,
        quantity: decimal,
        price: decimal,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};